<template>
  <!--  XXX duplicated w/ src/components/Widgets/AssociateReports/SalesSummary.vue ? -->
  <base-card custom class="px-3 pt-1 pb-2 orange">
    <base-heading class="title-card ">
      Sales Overview
    </base-heading>
    <hr style="border-color: #646464">
    <template v-if="loading">
      <div class="d-flex justify-content-between">
        <base-skeleton
          v-for="n in 4"
          :key="n"
          :opacity="0 + (1 /n)"
          class="mx-1 w-100"
        >
          <div class="d-flex flex-column justify-content-between py-4 text-center">
            <div
              class="skeleton__item ml-auto mr-auto"
              style="max-width: 80px"
            />
            <div
              class="skeleton__item ml-auto mr-auto"
              style="max-width: 30px"
            />
          </div>
        </base-skeleton>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-between mt-4 stats-container">
        <div
          v-for="(stat, index) in stats"
          :key="`stat_${index}`"
          :class="`w-100 text-center py-2 ${index < stats.length - 1 ? 'divider' : ''}`"
        >
          <base-text
            class="label"
            light
          >
            {{ stat.label }}
          </base-text>
          <base-text
            class="value"
            medium
          >
            {{ formatReportValue(stat) }}
          </base-text>
        </div>
      </div>
    </template>
  </base-card>
</template>
<script>
import utilsMixin from '@/_utilities/utilsMixin';

export default {
  name: 'AdminSalesSummary',
  mixins: [utilsMixin],
  props: {
    stats: { // grep -> sales_overview() & create_sales_overview_response()
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped lang="scss">

.divider { border-right: solid 1px #646464; }
.label { font-size: 15px; letter-spacing: -0.082px; }
.value { font-size: 17px; }

::v-deep .skeleton__container {
  background-color: rgba($clementine, 0.2) !important;
}
::v-deep .skeleton__item {
  background-color: rgba(black, 0.1) !important;
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
  margin-bottom: unset;
}
</style>
